import React from "react";
import {
  Building2, ShieldCheck, LineChart, Activity, FileText, BadgeCheck,
  Radar, ClipboardCheck, DoorOpen, Lock,
} from "lucide-react";

const TRUST_BADGES = [
  { icon: Building2, label: "Company Data Check" },
  { icon: ShieldCheck, label: "KYC-Based Onboarding" },
  { icon: LineChart, label: "Financial Confidence Labels" },
  { icon: Activity, label: "Basic Health Check" },
  { icon: FileText, label: "Detailed DD Report" },
  { icon: BadgeCheck, label: "VENTURAZ Trust Score" },
  { icon: Radar, label: "Investor Mandate Fit" },
  { icon: ClipboardCheck, label: "Controlled Query Workflow" },
  { icon: DoorOpen, label: "Secure Deal Rooms" },
  { icon: Lock, label: "Admin-Approved Data Sharing" },
];

export default function TrustBadgeStrip() {
  return (
    <section className="bg-navy/[0.02] border-y border-navy/10" data-testid="trust-badge-strip">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6">
        <div className="overflow-x-auto scrollbar-thin -mx-6 lg:mx-0 px-6 lg:px-0">
          <div className="flex items-center gap-2 md:justify-center md:flex-wrap min-w-max md:min-w-0">
            {TRUST_BADGES.map(({ icon: Icon, label }) => (
              <div
                key={label}
                className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-white border border-navy/10 text-[12px] font-mono uppercase tracking-wider text-ink-soft whitespace-nowrap hover:border-gold/60 hover:text-[#8A6600] transition-colors"
                data-testid={`trust-badge-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              >
                <Icon size={12} className="text-gold" />
                {label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
